import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "../../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { finalize } from "rxjs/operators";
import { UtilsService } from "../../../../utils/utils.service";

@Injectable({
  providedIn: "root",
})
export class UtilisateursService {
  // POUR LE CHARGEMENT (SPINNER)
  isLoading$: Observable<boolean>;
  isLoadingSubject: BehaviorSubject<boolean>;

  //URL DE BASE DU SERVICE A APPELER
  //*NB: environment.apiUrl --> CONTIENT L'ADRESSE IP DU SERVICE SPRING BOOT
  //*    '/users' est le controller à appeler

  userURL = environment.apiUrl + "user";
  authURL = environment.apiUrl + "auth";

  constructor(private _http: HttpClient) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
    this.isLoading$ = this.isLoadingSubject.asObservable();
  }

  getUsers() {
    this.isLoadingSubject.next(true);
    return this._http
      .get<any>(this.userURL)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }
  getUserById(id) {
    this.isLoadingSubject.next(true);
    return this._http
      .get<any>(this.userURL + "/" + id)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getUserByRole(role) {
    this.isLoadingSubject.next(true);
    // let param = new HttpParams();
    // param = param.append("role", role);
    return this._http
      .get<any>(this.userURL + "/role/"+role)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }
  getUserVent(type) {
    let param = new HttpParams();
    param = param.append("type", type);
    this.isLoadingSubject.next(true);
    return this._http.get<any[]>(this.userURL + "/vendeurs/list",{params:param})
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }
  // getUsersByDepartement(idDep) {
  //   this.isLoadingSubject.next(true);
  //   return this._http.get<any>(this.userURL+"/departement/"+idDep).pipe(
  //       finalize(() => this.isLoadingSubject.next(false))
  //   );
  // }

  saveUser(body: any) {
    this.isLoadingSubject.next(true);
    return this._http
      .post(this.userURL, body)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  updateUser(id: any, body: any) {
    this.isLoadingSubject.next(true);
    return this._http
      .put<any>(`${this.userURL}/${id}`, body)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }
  updateUserEtat(id: any, body: any) {
    this.isLoadingSubject.next(true);
    return this._http
      .put<any>(`${this.userURL}/state/${id}`, body)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }


  //ADMIN
  changeUserPassword(id: number, body: any) { 
    this.isLoadingSubject.next(true);
    return this._http
      .post<any>(`${this.userURL}/changePassword/${id}`, body)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  //USER
  changeMyPassword(id: number, body: string) {
    this.isLoadingSubject.next(true);
    return this._http
      .post<any>(
        `${this.authURL}/userChangePassword/${id}`,
        UtilsService.not_undefined(body) ? "null" : body.toString()
      )
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  deleteUser(id: number) {
    this.isLoadingSubject.next(true);
    return this._http
      .delete<any>(`${this.userURL}/${id}`)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }
}
